import React from 'react'
import CountUp from 'react-countup'
import { Waypoint } from 'react-waypoint'
import { i18n } from '../../../validator'
import Loader from '../../../front/components/shared/loader'
import Configurator from '../../../configurator'

const CountUpDuration = 3
const CountUpSeparator = '&nbsp;'

@i18n()
export default class LandingStatistics extends Configurator {

    state = {
        busy: false,
        data: null,
        statisticsLoaded: false,
    }

    componentDidMount() {
        this.loadStatistics()
    }

    /**
     * Fetch statistics from API
     */
    loadStatistics = () => {
        this.setState({ busy: true })

        window.axios.get(`${window.APP_CONFIG.REACT_APP_API_URL}api/stack${this.isOstravaSystem() ? '?city=ostrava' : ''}`)
            .then(({ data }) => {
                this.setState({
                    busy: false,
                    data,
                })
            })
    }

    /**
     * Method called when user scroll to this box with statistics
     * First time fetch statistics from API
     */
    onBoxScrolled = () => {
        const { statisticsLoaded } = this.state

        if (!statisticsLoaded) {
            this.setState({ statisticsLoaded: true })
        }
    }

    /**
     * Render one statistic
     * @param {number} count Number showed in one statistic
     * @param {string} label Label of statistic
     * @returns {*}
     */
    renderStatistic = (count, label) => (
        <div className="col-md Landing-box__statistic-box">
            <CountUp
                className="Landing-box__statistic-count"
                end={count}
                duration={CountUpDuration}
                separator={CountUpSeparator}
            />
            <div className="Landing-box__statistic-label">{label}</div>
        </div>
    )

    render() {
        const {
            busy,
            data,
            statisticsLoaded,
        } = this.state

        const { t } = this.props

        if (!data || busy) {
            return (
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <Loader />
                        </div>
                    </div>
                </div>
            )
        }

        if (!statisticsLoaded) {
            return <Waypoint onEnter={this.onBoxScrolled} />
        }

        return (
            <div className="container">
                {this.isOstravaSystem() &&
                    <div className="row">
                        {this.renderStatistic(125, t('statisticsGrants'))}
                        {this.renderStatistic(17, t('statisticsTopEvents'))}
                        {this.renderStatistic(15, t('statisticsSignificantProjects'))}
                        {this.renderStatistic(10, t('statisticsProjects'))}
                    </div>
                }
                <div className="row">
                    {this.renderStatistic(data.sportsCount, t('statisticsSports'))}
                    {this.renderStatistic(data.sportVenuesActive, t('statisticsSportVenues'))}
                    {this.renderStatistic(data.groupsActive, t('statisticsGroupsAndClubs'))}
                    {!this.isOstravaSystem() &&
                        this.renderStatistic(data.usersActive, t('statisticsUsers'))
                    }
                    {this.renderStatistic(data.eventsActive, t('statisticsEvents'))}
                </div>
            </div>
        )
    }
}
